var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { TweenService, Easings } from '../../animations';
import { PropertyConverters } from '../../converters';
import { PacemItemElement } from '../basic';
import { Watch } from '../../decorators';
//namespace Pacem.Components {
const EasingConverter = {
    convert: (attr) => Easings[attr] ?? Easings.linear
};
export class AnimationElement extends PacemItemElement {
}
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Element })
], AnimationElement.prototype, "target", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], AnimationElement.prototype, "property", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], AnimationElement.prototype, "delay", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], AnimationElement.prototype, "duration", void 0);
__decorate([
    Watch({ emit: false, converter: EasingConverter })
], AnimationElement.prototype, "easing", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], AnimationElement.prototype, "iterations", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], AnimationElement.prototype, "direction", void 0);
export class TweenAnimationElement extends AnimationElement {
    constructor(_tweener = new TweenService()) {
        super();
        this._tweener = _tweener;
    }
    get tweener() {
        return this._tweener;
    }
    #cancelToken = false;
    startAnimation() {
        this.#cancelToken = false;
        return new Promise((resolve, _) => {
            this._tweener
                .run(.0, 1.0, this.duration ?? 0, this.delay ?? 0, this.easing ?? Easings.linear, (t, v) => {
                if (!this.#cancelToken) {
                    this.target[this.property] = this.tweenInterpolationCallback(t, v);
                }
            })
                .then(resolve);
        });
    }
    cancelAnimation() {
        this.#cancelToken = true;
    }
}
